"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4931],{

/***/ 4931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TilesType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91932);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62290);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39806);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75547);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








function TilesType(props) {
    var builder = props.builder;
    var content = props.content;
    var articles = props.articles;
    var container_class = "container";
    if (props.type == "blog" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
        container_class = builder.builder_news_view_width;
    } else if (props.type == "category" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
        container_class = content.category_view_width;
    }
    var row_class = " p-0 ";
    if (props.type == "blog") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
            container_class = builder.builder_news_view_width;
        }
        row_class += " " + _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_radius") ? " border-radius-".concat(builder.builder_news_radius, "  ") : 0;
        row_class += " " + _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_shadow") ? " shadow-".concat(builder.builder_news_shadow, " ") : 0;
    } else if (props.type == "category") {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
            container_class = content.category_view_width;
        }
        row_class += " " + _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(content, "tiles_radius") ? " border-radius-".concat(content.tiles_radius) : 0;
        row_class += " " + _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(content, "tiles_shadow") ? " shadow-".concat(content.tiles_shadow) : 0;
    }
    var TileDiv = function(article, created, classNamesFromOptions, col_class, height) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            parentClassName: col_class,
            skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                height: height,
                width: "100%"
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: col_class,
                style: {
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "m-b-10 m-r-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                        href: props.updateHref(article),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: props.setClass(article, classNamesFromOptions.join(" ")) + " " + (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(props.itemClassName) ? props.itemClassName : "") + " " + row_class,
                            onClick: function() {
                                return props.clickHandler(article);
                            },
                            onMouseEnter: function(event) {
                                return props.updateHref(event, article);
                            },
                            style: {
                                cursor: article.has_description == "1" ? "pointer" : null
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-12 p-0 col-photo-tile",
                                    children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        layout: "responsive",
                                        width: 300,
                                        height: 300,
                                        sizes: "75vw",
                                        quality: "75",
                                        src: article.image,
                                        alt: "Post Img",
                                        placeholder: "blur",
                                        blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-12",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex flex-column h-100 py-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "text-uppercase hint-text fw-bold small-text text-master text-design-color",
                                                children: props.articlesContentType == "blog" ? created : article.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-master bold m-b-0 line-clamp-1",
                                                children: props.articlesContentType == "blog" ? article.title : props.articlesContentType == "category" ? article.description : article.subtitle
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }, article.id.toString())
        });
    };
    var SkeletonTileDiv = function(i, col_class, height) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: col_class,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                height: height,
                width: "100%"
            })
        }, i.toString());
    };
    //------------------------ DEVIDE THE ARRAY OF DIVS FOR THE ORDER ----------------------------------
    //------------------------ etc LEFT = [0,3,4,6], RIGHT = [1,2,5,7,8] -------------------------------
    var pointer = "left"; // left right
    var items_left = 1;
    var left_start_pos = 1;
    var items_right = 2;
    var right_start_pos = 2;
    var array_left = [];
    var array_right = [];
    var skeleton_array_left = [];
    var skeleton_array_right = [];
    for(var i = 0; i < 6; i++){
        var key = i;
        var classNamesFromOptions = [];
        classNamesFromOptions.push("row w-100 m-0 bg-white");
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_radius")) {
            classNamesFromOptions.push("border-radius-".concat(builder.builder_news_radius));
        }
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_shadow")) {
            classNamesFromOptions.push("shadow-".concat(builder.builder_news_shadow));
        }
        if (pointer == "left") {
            if (key + 1 == articles.length && left_start_pos == 2) {
                if (right_start_pos == 2) {
                    skeleton_array_left.push(SkeletonTileDiv(i, "col-12 col-sm-12 col-md-6 mb-4", 385));
                } else {
                    skeleton_array_right.push(SkeletonTileDiv(i, "col-12 col-sm-12 col-md-12 mb-4", 703));
                }
            } else {
                skeleton_array_left.push(SkeletonTileDiv(i, left_start_pos == 1 ? "col-12 col-sm-12 col-md-12 mb-4" : "col-6 col-sm-6 col-md-6 mb-4", left_start_pos == 1 ? 730 : 385));
            }
            items_left -= 1;
            if (items_left == 0) {
                pointer = "right";
                if (left_start_pos == 1) {
                    left_start_pos = 2;
                } else {
                    left_start_pos = 1;
                }
            }
            items_right = right_start_pos;
        } else if (pointer == "right") {
            if (key + 1 == articles.length && right_start_pos == 2) {
                if (left_start_pos == 2) {
                    skeleton_array_right.push(SkeletonTileDiv(i, "col-12 col-sm-12 col-md-6 mb-4", 385));
                } else {
                    skeleton_array_left.push(SkeletonTileDiv(i, "col-12 col-sm-12 col-md-12 mb-4", 703));
                }
            } else {
                skeleton_array_right.push(SkeletonTileDiv(i, right_start_pos == 1 ? "col-12 col-sm-12 col-md-12 mb-4" : "col-6 col-sm-6 col-md-6 mb-4", right_start_pos == 1 ? 730 : 385));
            }
            items_right -= 1;
            if (items_right == 0) {
                pointer = "left";
                if (right_start_pos == 1) {
                    right_start_pos = 2;
                } else {
                    right_start_pos = 1;
                }
            }
            items_left = left_start_pos;
        }
    }
    articles.map(function(article, key) {
        if (key === 0) {
            pointer = "left"; // left right
            items_left = 1;
            left_start_pos = 1;
            items_right = 2;
            right_start_pos = 2;
        }
        var classNamesFromOptions = [];
        classNamesFromOptions.push("row w-100 m-0 bg-white");
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_radius")) {
            classNamesFromOptions.push("border-radius-".concat(builder.builder_news_radius));
        }
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidObjString */ .Z.isValidObjString(builder, "builder_news_shadow")) {
            classNamesFromOptions.push("shadow-".concat(builder.builder_news_shadow));
        }
        var created = moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(article.created * 1000)).format("dddd Do MMMM");
        if (pointer == "left") {
            if (key + 1 == articles.length && left_start_pos == 2) {
                if (right_start_pos == 2) {
                    array_left.push(TileDiv(article, created, classNamesFromOptions, "col-12 col-sm-12 col-md-6 mb-4", 385));
                } else {
                    array_right.push(TileDiv(article, created, classNamesFromOptions, "col-12 col-sm-12 col-md-12 mb-4", 703));
                }
            } else {
                array_left.push(TileDiv(article, created, classNamesFromOptions, left_start_pos == 1 ? "col-12 col-sm-12 col-md-12 mb-4" : "col-6 col-sm-6 col-md-6 mb-4", left_start_pos == 1 ? 730 : 385));
            }
            items_left -= 1;
            if (items_left == 0) {
                pointer = "right";
                if (left_start_pos == 1) {
                    left_start_pos = 2;
                } else {
                    left_start_pos = 1;
                }
            }
            items_right = right_start_pos;
        } else if (pointer == "right") {
            if (key + 1 == articles.length && right_start_pos == 2) {
                if (left_start_pos == 2) {
                    array_right.push(TileDiv(article, created, classNamesFromOptions, "col-12 col-sm-12 col-md-6 mb-4", 385));
                } else {
                    array_left.push(TileDiv(article, created, classNamesFromOptions, "col-12 col-sm-12 col-md-12 mb-4", 703));
                }
            } else {
                array_right.push(TileDiv(article, created, classNamesFromOptions, right_start_pos == 1 ? "col-12 col-sm-12 col-md-12 mb-4" : "col-6 col-sm-6 col-md-6 mb-4", right_start_pos == 1 ? 730 : 385));
            }
            items_right -= 1;
            if (items_right == 0) {
                pointer = "left";
                if (right_start_pos == 1) {
                    right_start_pos = 2;
                } else {
                    right_start_pos = 1;
                }
            }
            items_left = left_start_pos;
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(container_class, " pb-5"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "row w-100 m-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-12",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row w-100 m-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-sm-12 col-md-6 col-lg-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: props.loadingArticles ? skeleton_array_left.map(function(element) {
                                    return element;
                                }) : array_left.map(function(element) {
                                    return element;
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 col-sm-12 col-md-6 col-lg-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row",
                                children: props.loadingArticles ? skeleton_array_right.map(function(element) {
                                    return element;
                                }) : array_right.map(function(element) {
                                    return element;
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}


/***/ })

}]);